<div class="img-db-pagination-container">
    <div
            class="image-meta"
            *ngIf="selectedImage && selectedImage?.processedUrl && !selectedImage?.error && type === 'annotate'"
        >
            <div
                class="meta-row"
                (click)="onCopyImageName()"
                [title]="selectedImage?.name"
                role="button"
                tabindex="0"
                aria-label="Copy image name"
            >
                <img
                    class="copy-icon"
                    src="assets/svg/img-db/labeling-dialog/icon-copy-to-clipboard-large.svg"
                    alt="copy-name"
                />
                <span class="meta-text">{{ selectedImage?.name }}</span>
            </div>
            <div
                class="meta-row"
                (click)="onCopyImageId()"
                [title]="selectedImage?.id"
                role="button"
                tabindex="0"
                aria-label="Copy image id"
            >
                <img
                    class="copy-icon"
                    src="assets/svg/img-db/labeling-dialog/icon-copy-to-clipboard-large.svg"
                    alt="copy-id"
                />
                <span class="meta-text">ID: {{ selectedImage?.id }}</span>
            </div>
        </div>
    <div class="paging-wrapper">
        <app-input-paging-bar
            [tag]="type"
            [maxValue]="totalPages"
            [currentValue]="currentPage"
            (nextValue)="onNextValue($event)"
        ></app-input-paging-bar>
    </div>
    <div class="zoom-control-group">
        <div class="zoom-control" (click)="onZoomOut()" id="zoom-out">
            <p>-</p>
        </div>
        <input
            [formControl]="zoomControl"
            type="range"
            class="indicator"
            [min]="minZoom"
            [max]="maxZoom"
            (change)="zoomChange()"
        />
        <div class="zoom-control" (click)="onZoomIn()" id="zoom-in">
            <p>+</p>
        </div>
    </div>
</div>
